import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { useGetCourtsListQuery } from '../store/Api';
import { CourtType } from '../store/types';

type Props = FormItemProps;

export const SelectCourt = ({ ...formProps }: Props) => {
  const { data: courts = [], isLoading } = useGetCourtsListQuery();

  if (isLoading) {
    return (<LoadingOutlined />);
  }

  return (
    <Form.Item
      label={t('table.court')}
      name="courtId"
      {...formProps}
    >
      <Select<CourtType>>
        {courts.map(({ id, name }) => (
          <Select.Option key={id} value={id}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
